import React from 'react';
import './StarrySky.scss'; // Adjust the path as needed

const StarrySky = () => {
  const numberOfStars = 100; // Number of stars
  const stars = Array.from({ length: numberOfStars }, (_, i) => ({
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    animationDelayFactor: Math.random()
  }));

  return (
    <div className="starry-sky">
      {stars.map((star, index) => (
        <div
          key={index}
          className="star"
          style={{ left: star.left, top: star.top, '--animation-delay-factor': star.animationDelayFactor }}
        />
      ))}
    </div>
  );
};

export default StarrySky;
